import { Box } from '@mui/material';
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../components/PageHeader/PageHeader';
import TransactionTable from '../../../components/TransactionsTable/TransactionTable';

const Transactions = () => {

  const { t } = useTranslation();
  const { locationId } = useParams();
  const terminalCode = localStorage.getItem('terminalId');
  
  return (
    <Box p={3}>
      <PageHeader title={t('transactions')} subtitle={t('manage_transactions')} />
      <Box mt={2}>
        <TransactionTable 
          bySeller
          locationId={locationId}
          terminalCode={terminalCode}
          showCancelFor="last"
        />
      </Box>
    </Box>
  );

};

export default Transactions;
